import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getConstraint = (state: RootState) => state.pages.editor.canvas.aspectRatioConstrainedType;

const AspectRatioConstrainedType = createSelector([getConstraint], (constraint) => constraint);

export default AspectRatioConstrainedType;
